// this file is generated by update_shopify_store_data.py at 2026-05-05 20:27:36.394100
var courses = [];